<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import LogoWhiteSvg from '@/assets/images/logo/asueneesg/logo-asueneesg-white.svg'
import LogoBlueSvg from '@/assets/images/logo/asueneesg/logo-asueneesg-blue.svg'

/**
 * Constants
 */
const COLORS = ['blue', 'white'] as const
const IMAGES = {
  'logo-asueneesg-white.svg': LogoWhiteSvg,
  'logo-asueneesg-blue.svg': LogoBlueSvg,
} as any

/**
 * Types
 */
type Color = (typeof COLORS)[number]

/**
 * Props
 */
type Props = {
  color: Color
}
const props = withDefaults(defineProps<Props>(), {
  color: 'blue',
})

/**
 * Compositions
 */
const { locale } = useI18n()

/**
 * Computed
 */
const color = computed(() =>
  COLORS.includes(props.color as any) ? props.color : 'blue',
)

const config = computed(() => {
  const baseFilePath = `logo-asueneesg-${color.value}`

  return {
    svg: IMAGES[`${baseFilePath}.svg`],
    alt:
      locale.value === 'ja'
        ? 'アスエネESG - ESG Cloud Rating'
        : 'ASUENE ESG - ESG Cloud Rating',
  }
})
</script>

<template>
  <div class="app-logo">
    <!-- eslint-disable-next-line -->
    <img :src="`${config.svg}`" :alt="`${config.alt}`" />
  </div>
</template>

<style scoped>
.app-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
